var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4803 4.46109L11.5003 8.20109C9.20031 9.06109 7.32031 11.7811 7.32031 14.2411V29.1011C7.32031 31.4611 8.88033 34.5611 10.7803 35.9811L19.3803 42.4011C22.2003 44.5211 26.8403 44.5211 29.6603 42.4011L38.2603 35.9811C40.1603 34.5611 41.7203 31.4611 41.7203 29.1011V14.2411C41.7203 11.7811 39.8403 9.06109 37.5403 8.20109L27.5603 4.46109C25.8603 3.84109 23.1403 3.84109 21.4803 4.46109Z",
    stroke: "#404650",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 31C28.9183 31 32.5 27.4183 32.5 23C32.5 18.5817 28.9183 15 24.5 15C20.0817 15 16.5 18.5817 16.5 23C16.5 27.4183 20.0817 31 24.5 31Z",
    stroke: "#404650",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.5V22.36C25 23.06 24.64 23.72 24.02 24.08L22.5 25",
    stroke: "#3055D9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorClock);
export default __webpack_public_path__ + "static/media/error-clock.a94a8bcddaf8b58f129fedd65f5902fc.svg";
export { ForwardRef as ReactComponent };